"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCondition = void 0;
const index_js_1 = require("../../../../errors/index.js");
const index_js_2 = require("./between/index.js");
const index_js_3 = require("./comparison/index.js");
const index_js_4 = require("./in/index.js");
const index_js_5 = require("./logicalCombination/index.js");
const index_js_6 = require("./not/index.js");
const index_js_7 = require("./singleArgFn/index.js");
const index_js_8 = require("./twoArgsFn/index.js");
const parseCondition = (conditionParser, condition) => {
    if ((0, index_js_3.isComparisonCondition)(condition)) {
        return (0, index_js_3.parseComparisonCondition)(conditionParser, condition);
    }
    if ((0, index_js_7.isSingleArgFnCondition)(condition)) {
        return (0, index_js_7.parseSingleArgFnCondition)(conditionParser, condition);
    }
    if ((0, index_js_2.isBetweenCondition)(condition)) {
        return (0, index_js_2.parseBetweenCondition)(conditionParser, condition);
    }
    if ((0, index_js_6.isNotCondition)(condition)) {
        return (0, index_js_6.parseNotCondition)(conditionParser, condition);
    }
    if ((0, index_js_5.isLogicalCombinationCondition)(condition)) {
        return (0, index_js_5.parseLogicalCombinationCondition)(conditionParser, condition);
    }
    if ((0, index_js_8.isTwoArgsFnCondition)(condition)) {
        return (0, index_js_8.parseTwoArgsFnCondition)(conditionParser, condition);
    }
    if ((0, index_js_4.isInCondition)(condition)) {
        return (0, index_js_4.parseInCondition)(conditionParser, condition);
    }
    throw new index_js_1.DynamoDBToolboxError('actions.invalidCondition', {
        message: 'Invalid condition: Unable to detect valid condition type.'
    });
};
exports.parseCondition = parseCondition;
